var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emd-modal", {
    attrs: { open: _vm.isOpen, "has-header": "", "has-footer": "" },
    on: { close: () => _vm.$emit("onCancel") },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h2", { staticClass: "emd-text _size_section" }, [
              _vm._v(" " + _vm._s(_vm.title) + " "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "eu-display_flex eu-mt_2" }, [
              _c("p", [
                _vm._v(" " + _vm._s(_vm.textParagraph[0]) + " "),
                _c("strong", [_vm._v(_vm._s(_vm.textParagraph[1]))]),
                _vm._v(" " + _vm._s(_vm.textParagraph[2]) + " "),
              ]),
            ]),
            _vm.resetText
              ? _c("p", { staticClass: "eu-mt_4 _paragraph_color_success" }, [
                  _vm._v(" " + _vm._s(_vm.resetText) + " "),
                ])
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "eu-display_flex eu-justify_end eu-width_100" },
              [
                _c("emd-button", {
                  attrs: {
                    "data-testid": "button-cancel",
                    color: "primary",
                    type: "text",
                    text: _vm.$t(
                      "modal.reset-secret-key.modal-confirm.button-1"
                    ),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onCancel")
                    },
                  },
                }),
                _c(
                  "emd-button",
                  {
                    attrs: {
                      "data-testid": "button-reset-secret-key",
                      color: "success",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onSubmit")
                      },
                    },
                  },
                  [_c("span", [_vm._v(" " + _vm._s(_vm.textSubimit) + " ")])]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }